<template>
  <v-card :loading="waiting">
    <v-card-title>
      <span class="headline">Edit SC Account Name</span>
    </v-card-title>
    <v-card-text>

      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-if="accountname == null"
              type="name"
              color="#4dbac0"
              label="Sierra Chart Account Name"
              v-model="typedname"
            ></v-text-field>
            <v-layout v-else justify-center>{{accountname}}</v-layout>
            <div class="errors">
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </div>
            <div class="successes">
              <li v-for="(success, index) in successes" :key="index">{{success}}</li>
            </div>
          </v-col>
        </v-row>
      </v-container>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn disabled v-if="apikey != null" color="blue darken-1" text @click="info">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn v-if="accountname != null" color="blue darken-1" text @click="remove">
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      <v-btn v-if="accountname == null" color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "editScAccount",
      errors: new Array(),
      successes: new Array(),
      typedname: this.$store.getters.accountSierraChart,
      waiting: false
    };
  },
  computed: {
    accountname() {
      return this.$store.getters.accountSierraChart;
    }
  },
  methods: {
    close() {
      this.$emit("close", this.name);
    },

    save() {
        
      this.errors = [];
        this.successes = [];
      if (this.typedname == null || this.typedname ==  "") {
        this.errors.push("Type your SC Account Name");
      }
      //479747
      if (this.errors.length == 0) {
          this.waiting = true
        this.$store
          .dispatch("updatePlatformAccount", {
            type: "sierrachart",
            name: "accountname",
            action: "add",
            value: this.typedname
          })
          .then(response => {
              this.waiting = false
            //this.$emit("close", this.name);
            //if (response.data.message[0] == "ERROR") {
              this.successes.push(response.data.message[1]);
              this.waiting = false
            //}
          })
          .catch(err => {
            this.errors.push(err.data.message[1]);
            this.waiting = false
            //this.errors.push(err);
          });
      }
    },

    remove() {
        this.errors = [];
        this.successes = [];
        this.waiting = true
      this.$store
        .dispatch("removePlatformAccount", {
          type: "sierrachart",
          name: "accountname",
          action: "remove",
          value: this.accountname
        })
        .then(response => {
              this.waiting = false
            //this.$emit("close", this.name);
            //if (response.data.message[0] == "ERROR") {
              this.successes.push(response.data.message[1]);
              this.waiting = false
              this.typedname = null
            //}
          })
          .catch(err => {
            this.errors.push(err.data.message[1]);
            this.waiting = false
            //this.errors.push(err);
          });
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>